import React, { useContext, useEffect, useState } from 'react';
import CollapsedUspModal from './collapsed-usp-modal';
import ExpandedUspModal from './expanded-usp-modal';
import { UIContext, MediaContext } from '../context';
import { connect, useSelector } from 'react-redux';
import { useUspHotspot } from '../hooks/useUspHotspot';
import { capitalize } from './uspUtils';
import { setIncrementClicked, setDecrementClicked, setToggleHotspotView, setIncrementClickedInterior, setDecrementClickedInterior, setToggleInteriorHotspot, setInteriorHotspotIndex, setHotspotClickedIndex } from '../../../Redux/Reducers/View360Reducer/View360ActionController'

const UspComponentT2 = (props) => {
  const { isExpanded, setIsExpanded } = useContext(UIContext);
  const { enterpriseId } = useContext(MediaContext);
  const [isSpanishEnterprise, setIsSpanishEnterprise] = useState(false);
  const interiorHotspotIndex = useSelector(state => state.view360Reducer.interiorHotspotIndex);
  const toggleInteriorHotspots = useSelector(state => state.view360Reducer.toggleInteriorHotspots);
  const {
    currentUsp,
    combinedHotspotData,
    dropdownSelection,
    hotspotClickedIndex,
    handleNext,
    handlePrev,
    handleNextCollapsed,
    handlePrevCollapsed,
    toggleExpand: hookToggleExpand,
    handleHotspotClick,
    toggleHotspotView,
    useAutoCycle
  } = useUspHotspot(props);
  let spanishEnterprises = ['2d410b1b9','204fffd0d','858b283d5']  // TODO: get from backend
  let isSpanishEnterpriseFn = (enterpriseId) => {
      return spanishEnterprises.includes(enterpriseId);
  }
  useEffect(() => {
    if(isSpanishEnterpriseFn(enterpriseId)){
      setIsSpanishEnterprise(true);
    }
  }, [enterpriseId])
  useEffect(() => {
    setIsExpanded((interiorHotspotIndex !== -1 && dropdownSelection === "INT") ? true : false)
  }, [interiorHotspotIndex,toggleInteriorHotspots])

  useEffect(() => {
    setIsExpanded((hotspotClickedIndex !== -1 && dropdownSelection === "EXT") ? true : false)
  }, [hotspotClickedIndex])

  useAutoCycle(isExpanded);

  const toggleExpand = () => {
    hookToggleExpand(isExpanded, setIsExpanded);
  };

  useEffect(() => {
    if(!props.toggleHotspotView || toggleInteriorHotspots){
      setIsExpanded(false);
    }
  }, [props.toggleHotspotView, toggleInteriorHotspots]);
  useEffect(() => {
    if(toggleHotspotView && !isExpanded) {
      handleHotspotClick(setIsExpanded);
    }
  }, [toggleHotspotView, isExpanded, handleHotspotClick]);
  
  return (
    <>
      {combinedHotspotData?.length > 0 && (
        <div className={`w-full h-full ${isExpanded ? 'p-2' : 'px-2'} md:pr-4`}>
          {isExpanded ? (
            <ExpandedUspModal 
              capitalize={capitalize}
              dropdownSelection={currentUsp?.type || dropdownSelection}
              modalList={currentUsp || {}}
              uspData={currentUsp} 
              onClose={toggleExpand} 
              onNext={handleNext}
              onPrev={handlePrev}
              hotspotClickedIndex={hotspotClickedIndex}
              currentItemType={currentUsp?.type}
              isSpanishEnterprise={isSpanishEnterprise}
            />
          ) : (
            // <CollapsedUspModal 
            //   capitalize={capitalize}
            //   dropdownSelection={currentUsp?.type || dropdownSelection}
            //   modalList={currentUsp || {}}
            //   uspData={currentUsp}
            //   onViewClick={toggleExpand} 
            //   onNext={handleNextCollapsed}
            //   onPrev={handlePrevCollapsed}
            //   hotspotClickedIndex={hotspotClickedIndex}
            //   currentItemType={currentUsp?.type}
            //   isSpanishEnterprise={isSpanishEnterprise}
            // />
            null
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  incrementClicked: state.view360Reducer.incrementClicked,
  decrementClicked: state.view360Reducer.decrementClicked,
  incrementClickedInterior: state.view360Reducer.incrementClickedInterior,
  decrementClickedInterior: state.view360Reducer.decrementClickedInterior,
  toggleInteriorHotspots: state.view360Reducer.toggleInteriorHotspots,
  interiorHotspotIndex: state.view360Reducer.interiorHotspotIndex,
  hotspotClickedIndex: state.view360Reducer.hotspotClickedIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClicked,
  setDecrementClicked,
  setToggleHotspotView,
  setIncrementClickedInterior,
  setDecrementClickedInterior,
  setToggleInteriorHotspot,
  setInteriorHotspotIndex,
  setHotspotClickedIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentT2); 